import { useState } from 'react'
import { Link } from 'react-router-dom'
import { api, qs } from '../../lib/api.js'
import { Badge, Card, Empty, ErrorBox, Page, Spinner, useAsync } from '../../components/Ui.jsx'
import { fmtDate, fmtStamp, lakh } from '../../lib/format.js'

const STEP = {
  assigned: { label: 'Go to the hatchery', tone: 'warn' },
  packing: { label: 'Packed — start the trip', tone: 'info' },
  in_transit: { label: 'On the road', tone: 'info' },
  delivered: { label: 'Delivered', tone: 'good' },
  issue: { label: 'Issue flagged', tone: 'bad' }
}

export default function Trips () {
  const [status, setStatus] = useState('open')
  const { data, error, loading, reload } = useAsync(() => api.get(`/liaison/trips${qs({ status })}`), [status], { live: ['trips'] })
  const trips = data?.trips || []

  return (
    <Page
      title="My trips"
      subtitle="You travel with the vehicle from the hatchery gate to the pond: verify the packing, carry the certificates, hand over against the farmer's OTP."
    >
      <Card padded={false}>
        <div className="filterbar">
          <div className="chips">
            {[['open', 'Active'], ['delivered', 'Delivered'], ['', 'All']].map(([v, label]) => (
              <button key={label} className={`chip ${status === v ? 'on' : ''}`} onClick={() => setStatus(v)}>{label}</button>
            ))}
          </div>
        </div>

        {loading
          ? <Spinner />
          : error
            ? <div className="body"><ErrorBox error={error} onRetry={reload} /></div>
            : (
              <div className="scroll-x">
                <table>
                  <thead>
                    <tr><th>Trip</th><th>Pick up from</th><th>Deliver to</th><th className="num">Load</th><th>Stocking</th><th>Next step</th><th /></tr>
                  </thead>
                  <tbody>
                    {trips.map(t => (
                      <tr key={t._id}>
                        <td className="mono">{t.tripCode}<span className="t-sub">{t.vehicle?.regNo}</span></td>
                        <td>{t.order?.hatchery?.name}<span className="t-sub">{t.order?.hatchery?.village}</span></td>
                        <td>{t.order?.farmer?.name}<span className="t-sub">{[t.order?.farmer?.village, t.order?.farmer?.mandal].filter(Boolean).join(', ')} · {t.distanceKm} km</span></td>
                        <td className="num">{lakh(t.order?.quantityLakh)}<span className="t-sub">{t.bagsLoaded ? `${t.bagsLoaded} bags` : 'not packed'}</span></td>
                        <td className="tight">{fmtDate(t.order?.targetStockingDate)}</td>
                        <td>
                          <Badge tone={STEP[t.status]?.tone || 'muted'}>{STEP[t.status]?.label || t.status}</Badge>
                          {t.deliveredAt && <span className="t-sub">{fmtStamp(t.deliveredAt)}</span>}
                        </td>
                        <td className="right"><Link className="btn sm primary" to={`/liaison/trips/${t._id}`}>Open</Link></td>
                      </tr>
                    ))}
                    {!trips.length && <tr><td colSpan={7}><Empty>No trips assigned to you in this view.</Empty></td></tr>}
                  </tbody>
                </table>
              </div>
              )}
      </Card>
    </Page>
  )
}
